import Vue from "vue";
import vailcode from "@utils/errcode";
import lang from "@i18n/i18nOption.json";
const { langDefault, langList } = lang;
import web3Wallet from "@web3Wallet/index";

export default {
  namespaced: true,
  state: {
    isMobile: true,
    isLang: "En",
    balance: {}, //代币余额
    isConnect: null,
    netId: null,
    address: "",
    mPath: false,
    btnWalletLoading: false,
    htmlSize: {
      w: 0,
      h: 0,
    },
    isWallet: null,
  },
  mutations: {
    setIsWallet: (state, payload) => {
      state.isWallet = payload;
    },
    setHtmlSize: (state, payload) => {
      for (const key in payload) {
        Vue.prototype.$set(state.htmlSize, key, payload[key]);
      }
    },
    setBalance: (state, payload) => {
      for (const key in payload) {
        Vue.prototype.$set(state.balance, key, payload[key]);
      }
    },
    setBtnWalletLoading: (state, payload) => {
      state.btnWalletLoading = payload;
    },
    setLang: (state, payload) => {
      state.isLang = payload;
    },
    setBalance: (state, payload) => {
      for (const key in payload) {
        Vue.prototype.$set(state.balance, key, payload[key]);
      }
    },
    setIsMobile: (state, payload) => {
      state.isMobile = payload;
    },
    setWeb3Info: (state, payload) => {
      for (const key in payload) {
        state[key] = payload[key];
      }
    },
    setMpath: (state, payload) => {
      state.mPath = payload;
    },
  },
  actions: {
    //获取余额
    getBalance: async ({ commit }) => {
      try {
        const { value, formatted } = await _v.web3Wallet.getBalance(_v.web3Wallet.address);
        commit("setBalance", {
          value: BigNumber(value).toFixed(0),
          label: formatted,
        });
        // console.log(state.balance);
      } catch (err) {}
    },
    //连接web3
    doConnect: async ({ commit, dispatch }, bool = false) => {
      return new Promise(async (resolve, reject) => {
        try {
          await _v.web3Wallet.connect();
          resolve();
        } catch (err) {
          console.log("doConnect Error: ", err);
        }
      });
    },
  },
  getters: {
    isWeb3Wallet: (state) => {
      return state.isConnect === "connected" && Boolean(state.netId) && Boolean(state.address);
    },
  },
};
